<div class="not-found-container" fxLayout="column" fxLayoutAlign="center center">
  <h1>404</h1>
  <h2>{{ 'PAGENOTFOUND.MESSAGE' | translate }}</h2>
</div>
